import { createBrowserClient } from '@supabase/ssr';
import type { Database } from '@/types/database.types';
import type { TypedSupabaseClient } from '@/types/supabase';

// Singleton pattern to prevent multiple client instances
let supabaseClient: TypedSupabaseClient | null = null;

export function createClient(): TypedSupabaseClient {
  // Return existing client if already created
  if (supabaseClient) {
    return supabaseClient;
  }

  // ✅ FIX: Check env vars before creating client (prevents test crashes)
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  // In tests or when env vars missing, return mock client
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('[Supabase Client] Missing env vars - using mock client');
    return {} as TypedSupabaseClient;
  }

  // Create new client only if one doesn't exist
  supabaseClient = createBrowserClient<Database>(supabaseUrl, supabaseAnonKey);

  return supabaseClient;
}

/**
 * Get the Supabase client instance (lazy initialization)
 * Use this instead of importing a singleton to avoid build-time initialization
 */
export function getClient(): TypedSupabaseClient {
  return createClient();
}

// DEPRECATED: Use getClient() instead to avoid build-time initialization
// Export singleton instance directly for backward compatibility
// In tests/SSR, this will be a mock object, not null
export const supabase = typeof window !== 'undefined' ? createClient() : ({} as any);
